import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { JudgePortal } from './JudgePortal';

export const AdminJudgePreview = () => {
  const { token, isAdmin, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!isAdmin) { navigate('/members/login'); return null; }

  return <JudgePortal previewMode authToken={token} />;
};

export default AdminJudgePreview;
